module.exports = __webpack_public_path__ + "static/img/page7_img2.bd8234f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img2.jpg
// module id = nmWr
// module chunks = 1